import { render, staticRenderFns } from "./PaywallFeaturesList.vue?vue&type=template&id=db4433a8&scoped=true&"
import script from "./PaywallFeaturesList.vue?vue&type=script&lang=ts&"
export * from "./PaywallFeaturesList.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallFeaturesList.vue?vue&type=style&index=0&id=db4433a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4433a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('db4433a8', component.options)
    } else {
      api.reload('db4433a8', component.options)
    }
    module.hot.accept("./PaywallFeaturesList.vue?vue&type=template&id=db4433a8&scoped=true&", function () {
      api.rerender('db4433a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/PaywallFeaturesList.vue"
export default component.exports